'use client';

import { useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

export default function ReviewOwnerActions({ reviewId }: { reviewId: string }) {
  const router = useRouter();
  const [busy, setBusy] = useState(false);

  const onDelete = async () => {
    if (!window.confirm('이 글을 삭제하시겠습니까? 첨부한 사진도 함께 삭제됩니다.')) return;
    setBusy(true);
    const res = await fetch(`/api/reviews/${reviewId}`, { method: 'DELETE' });
    if (!res.ok) {
      const j = await res.json().catch(() => null);
      window.alert(j?.error ?? '삭제에 실패했습니다.');
      setBusy(false);
      return;
    }
    router.replace('/reviews');
    router.refresh();
  };

  return (
    <div data-component-id="src/components/member/ReviewOwnerActions.tsx:26:4" data-component-path="src/components/member/ReviewOwnerActions.tsx" data-component-line="26" data-component-end-line="37" data-component-file="ReviewOwnerActions.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20gap-2%22%7D" className="flex gap-2">
      <Link data-component-id="src/components/member/ReviewOwnerActions.tsx:27:6" data-component-path="src/components/member/ReviewOwnerActions.tsx" data-component-line="27" data-component-end-line="29" data-component-file="ReviewOwnerActions.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22px-4%20py-2%20border%20border-border%20rounded-lg%20bg-white%20hover%3Abg-secondary%20transition-smooth%20text-sm%20font-semibold%22%2C%22textContent%22%3A%22%EC%88%98%EC%A0%95%22%7D" href={`/reviews/${reviewId}/edit`} className="px-4 py-2 border border-border rounded-lg bg-white hover:bg-secondary transition-smooth text-sm font-semibold">
        수정
      </Link>
      <button data-component-id="src/components/member/ReviewOwnerActions.tsx:30:6" data-component-path="src/components/member/ReviewOwnerActions.tsx" data-component-line="30" data-component-end-line="36" data-component-file="ReviewOwnerActions.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22px-4%20py-2%20border%20border-border%20rounded-lg%20bg-white%20hover%3Abg-secondary%20transition-smooth%20text-sm%20font-semibold%20text-red-600%20disabled%3Aopacity-50%22%2C%22textContent%22%3A%22%EC%82%AD%EC%A0%9C%22%7D"
        onClick={onDelete}
        disabled={busy}
        className="px-4 py-2 border border-border rounded-lg bg-white hover:bg-secondary transition-smooth text-sm font-semibold text-red-600 disabled:opacity-50"
      >
        삭제
      </button>
    </div>
  );
}
